import type { Exercise } from '../types/dataModel';

/**
 * Filter exercises by name only (and optional muscle group). No description matching.
 * Sort: favorites first (id in favoriteExerciseIds), then alphabetical by name.
 */
export function filterAndSortExercisesByName(
  exercises: Exercise[],
  searchTerm: string,
  favoriteExerciseIds: Set<string> | string[] | null | undefined,
  muscleGroupFilter: string = 'all'
): Exercise[] {
  const term = (searchTerm ?? '').trim().toLowerCase();
  const favoriteSet = favoriteExerciseIds instanceof Set
    ? favoriteExerciseIds
    : Array.isArray(favoriteExerciseIds)
      ? new Set(favoriteExerciseIds)
      : new Set<string>();

  const filtered = exercises.filter((ex) => {
    const nameMatch = !term || (ex.name ?? '').toLowerCase().includes(term);
    const muscleMatch =
      !muscleGroupFilter ||
      muscleGroupFilter === 'all' ||
      (ex.muscleGroup ?? '').toLowerCase() === muscleGroupFilter.toLowerCase();
    return nameMatch && muscleMatch;
  });

  return filtered.sort((a, b) => {
    const aFav = favoriteSet.has(a.id);
    const bFav = favoriteSet.has(b.id);
    if (aFav !== bFav) return aFav ? -1 : 1;
    const aName = (a.name ?? '').toLowerCase();
    const bName = (b.name ?? '').toLowerCase();
    return aName.localeCompare(bName);
  });
}
